import { Component, OnInit } from '@angular/core';
import { ButtonDisableDirective } from 'utils/directives/helper/button-disable';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss'],
  imports: []
})
export class PrivacyModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirm() {
    this.activeModal.close('confirmed');
  }

  cancel() {
    this.activeModal.dismiss('cancelled');
  }
}
